export const year2023 = [
  { year: 2023 },
  {
    name: 'NestJS Fundamentals',
    author: 'Kamil Mysliwiec & Mark Pieszak',
    type: 'Course',
    link: 'https://learn.nestjs.com/p/fundamentals',
    repo: 'https://github.com/andreidobrinski/nestjs-fundamentals-course',
  },
  {
    name: 'NestJS: The Complete Developers Guide',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/nestjs-the-complete-developers-guide/',
    repo: 'https://github.com/andreidobrinski/nestjs-complete-developers-guide-course-udemy',
  },
  {
    name: 'CSS Animations and Transitions',
    author: 'David Khourshid',
    type: 'Course',
    link: 'https://frontendmasters.com/courses/css-animations',
    repo: 'https://github.com/andreidobrinski/css-animations-and-transitions-fm-course',
  },
  {
    name: 'Build a Realtime Chat App with Remix and Supabase',
    author: 'Jon Meyers',
    type: 'Course',
    link: 'https://egghead.io/courses/build-a-realtime-chat-app-with-remix-and-supabase-d36e2618',
    repo: 'https://github.com/andreidobrinski/realtime-chat-app-remix-supabase-egghead-course',
  },
];
